import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { TeslaAutocompleteComponent } from '@tesla/angular2-tesla-common/autocomplete/autocomplete.component';
import { SelectedAutocompleteValue } from '@tesla/angular2-tesla-common/autocomplete/autocomplete.model';
import * as moment from 'moment';
import { NGXLogger } from 'ngx-logger';
import { of } from 'rxjs';
import { AppSettings } from 'src/app/app.settings';
import { BaseGridPage } from 'src/app/core/basepages/allbasepages';
import { Constants } from 'src/app/core/constants';
import Helper from 'src/app/core/utility/helper';
import { PartSystemDTO } from 'src/app/models/external/partsystem-dto';
import { QueryByStatusDTO } from 'src/app/models/internal/query-bystatus-dto';
import { ReviewProposalPartInfo } from 'src/app/models/internal/reviewproposalpartinfo2';
import { PartInfo } from 'src/app/models/partinfo';
import { SourceType } from 'src/app/models/sourcetype';
import { DataService } from 'src/app/services/data.service';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { ProposalService } from 'src/app/services/proposal.service';
import { ToastService } from 'src/app/services/toaster/toaster.service';
import { PackageType } from 'src/app/models/packagetype';

@Component({
  selector: 'app-pendinginspectionproposallist',
  templateUrl: './pendinginspectionproposallist.component.html',
  styleUrls: ['./pendinginspectionproposallist.component.scss']
})
export class PendinginspectionproposallistComponent extends BaseGridPage implements OnInit, AfterViewInit {
  appSettings : AppSettings;
  partProposalInfoList: ReviewProposalPartInfo[];
  partInfoIds: number[];
  autoCompletePEURL: string;
  searchSupplierURL: string;
  isTeslaCreatedList: any[] = [];
  isInboundShipment: boolean = true;
  allItemsCheckBoxSelected: boolean = false;
  filterForm: FormGroup;
  engineerDisplay: string;
  @ViewChild('PEAutoComplete') PEAutoComplete: TeslaAutocompleteComponent;
  @ViewChild('SupplierAutoComplete') SupplierAutoComplete: TeslaAutocompleteComponent;
  sourceTypeList: SourceType[];
  partSystemList: PartSystemDTO[];
    packageTypeList: PackageType[];

  constructor(
      private dataService: DataService,
      private proposalService: ProposalService,
      localstorageService: LocalstorageService,
      private router: Router,
      private fb: FormBuilder,
      logger: NGXLogger,
      appSettings: AppSettings,
    private toastService: ToastService,
  ) {
      super(localstorageService, logger, appSettings);
      this.appSettings = appSettings;
      this.autoCompletePEURL = this.appSettings.Packaging2APIUrl + '/peassignment/pe/all';
      this.searchSupplierURL = this.appSettings.Packaging2APIUrl + '/externaldata/supplier/all';
          this.filterForm = this.fb.group({
          PartNumber: [null],
          PartDescription: [null],
          SupplierCode: [null],
          IsTeslaCreated: [null],
          EffectiveFrom: [null],
          CreatedOn: [null],
          EngineerUserId: [null],
          SourceTypeId: [null],
          PartCategoryId: [null],
              IsTeslaUpdated: [false],
              PackageTypeId: [null]
      });

      this.isTeslaCreatedList.push({'Description': 'Yes', 'Value': 1});
      this.isTeslaCreatedList.push({'Description': 'No', 'Value': 0});

  }

  ngOnInit() {
      this.getSourceTypes();
      this.getPartSystems();
      this.getPackageTypes();
      this.dataService.getMe().subscribe((response: any) => {
          this.initFilterValues();
          if (response != null && response['Data'] != null && response['Data'][0] != null) {
              this.filterForm.controls['EngineerUserId'].patchValue(response['Data'][0]['UserId']);
              this.PEAutoComplete.selected = new SelectedAutocompleteValue();
              this.PEAutoComplete.selected.Description = response['Data'][0]['DisplayName'];
          }
          this.getPendingInspectionProposals();
      });
  }

  fillGrid(): void {
      this.filter.Skip = this.skip;
      this.filter.Take = this.pageSize;
      this.allItemsCheckBoxSelected = false;
      this.getPendingInspectionProposals();
  }
  UpdateFilter() {
      this.filter.SearchFilterConditions = [];
      this.filter = this.setFilterCondition(this.filter, this.filterForm, 'PartNumber', Constants.FILTER_DATATYPE_STRING,  Constants.FILTER_OPERATOR_TYPE_LIKE);
      this.filter = this.setFilterCondition(this.filter, this.filterForm, 'PartDescription', Constants.FILTER_DATATYPE_STRING,  Constants.FILTER_OPERATOR_TYPE_LIKE);
      this.filter = this.setFilterCondition(this.filter, this.filterForm, 'SupplierCode', Constants.FILTER_DATATYPE_STRING,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
      this.filter = this.setFilterCondition(this.filter, this.filterForm, 'IsTeslaCreated', Constants.FILTER_DATATYPE_NUMBER,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
      this.filter = this.setFilterCondition(this.filter, this.filterForm, 'EffectiveFrom', Constants.FILTER_DATATYPE_DATETIME,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
      this.filter = this.setFilterCondition(this.filter, this.filterForm, 'CreatedOn', Constants.FILTER_DATATYPE_DATETIME,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
      this.filter = this.setFilterCondition(this.filter, this.filterForm, 'EngineerUserId', Constants.FILTER_DATATYPE_NUMBER,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
      this.filter = this.setFilterCondition(this.filter, this.filterForm, 'SourceTypeId', Constants.FILTER_DATATYPE_NUMBER,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
      this.filter = this.setFilterCondition(this.filter, this.filterForm, 'PartCategoryId', Constants.FILTER_DATATYPE_NUMBER,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
      this.filter = this.setFilterCondition(this.filter, this.filterForm, 'IsTeslaUpdated', Constants.FILTER_DATATYPE_NUMBER,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
      this.filter = this.setFilterCondition(this.filter, this.filterForm, 'PackageTypeId');
  }
  clearFilter() {
      this.PEAutoComplete.selected.Description = '';
      this.filterForm.reset();
      this.filterForm.controls['IsTeslaUpdated'].setValue(false);
      this.filter.SearchFilterConditions = [];
      this.search();
  }
  deleteProposal(proposalId) {
          if (Helper.confirmDeleteAction()) {
              this.dataService.deleteProposal(proposalId).subscribe((response: any) => {
                  if (response != null && response.Success) {
                      this.toastService.success('Proposal deleted successfully', true);
                      this.fillGrid();
                  } else {
                      this.toastService.error(
                          'Could not delete the proposal'
                      );
                  }
              });
          } else {
          this.toastService.info('You cancelled the delete request');
          }
      }
  getPendingInspectionProposals() {
      this.UpdateFilter();
      const queryByStatusDTO: QueryByStatusDTO = new QueryByStatusDTO();
      queryByStatusDTO.SearchFilter = this.filter;
      this.dataService
          .getProposalsWithPendingPhysicalInspection(queryByStatusDTO)
          .subscribe((response: any) => {
              // this.partInfo = response
              if (response != null) {
                  this.partProposalInfoList = response.Data;
                  this.gridView = of({
                      data: response.Data,
                      total: response.Total ? response.Total : 0,
                  });
              }
              if (this.partProposalInfoList.length === 0) {
                  this.mainGrid = undefined;
              }
          });
  }

  getPackageType(packageTypeId) {
      return Helper.getPackageTypeDescription(packageTypeId);
  }

  formatDate(unformattedDate: Date) {
      return Helper.formatDate(unformattedDate);
  }

  getEffectiveTo(unformattedDate: Date) {
      const futureDate = new Date(
          moment()
              .add(5, 'years')
              .calendar()
      );
      if (unformattedDate <= futureDate) {
          return Helper.formatDate(unformattedDate);
      } else {
          return 'End of time';
      }
  }

  navigateToUpdateProposal(id: number) {
    // window.location.href = '/proposal/' + id;
    this.router.navigate(['../', 'proposal', id], { queryParams: { md: 'pi' } }); // mode = physical inspection
}

  onRowSelectedChange(isSelected: boolean, partInfo: PartInfo) {
      if (isSelected) {
          this.partProposalInfoList.find(
              a => a.Id === partInfo.Id
          ).IsSelected = true;
          if (
              this.partProposalInfoList.filter(a => a.IsSelected === true)
                  .length === this.partProposalInfoList.length
          ) {
              this.allItemsCheckBoxSelected = true;
          }
      } else {
          this.partProposalInfoList.find(
              a => a.Id === partInfo.Id
          ).IsSelected = false;
          this.allItemsCheckBoxSelected = false;
      }
      this.proposalService.RefreshpartInfoToBeCreatedList(
          this.partProposalInfoList
      );
      // console.log(this.partinfoList);
  }

  setAllSelected(isSelected: boolean) {
      // this.partinfoList.map(function(part) {
      //     part.IsSelected = isSelected;
      //     return part;
      // });
      this.partProposalInfoList.forEach(part => {
          part.IsSelected = isSelected;
      });
      this.proposalService.RefreshpartInfoToBeCreatedList(
          this.partProposalInfoList
      );
  }

  getAllSelectedOrNot(getSelected: boolean): number[] {
      return this.partProposalInfoList
          .filter(a => a.IsSelected === getSelected)
          .map(prop => prop.Id);
  }

  ValidateForm() {
      // console.log(this.gridData);
  }

  onEmptyPE(eventObj: any): void {
      this.filterForm.controls['EngineerUserId'].patchValue(null);
      this.PEAutoComplete.list = [];
      if (this.filter != null && this.filter.SearchFilterConditions != null && this.filter.SearchFilterConditions.findIndex(x => x.Field === 'EngineerUserId') >= 0) {
          this.filter.SearchFilterConditions.splice(this.filter.SearchFilterConditions.findIndex(x => x.Field === 'EngineerUserId'), 1);
      }
  }
  onEmptySupplierCode(eventObj: any): void {
      this.filterForm.controls['SupplierCode'].patchValue(null);
      this.SupplierAutoComplete.list = [];
      if (this.filter != null && this.filter.SearchFilterConditions != null && this.filter.SearchFilterConditions.findIndex(x => x.Field === 'SupplierCode') >= 0) {
          this.filter.SearchFilterConditions.splice(this.filter.SearchFilterConditions.findIndex(x => x.Field === 'SupplierCode'), 1);
      }
  }

  getSourceTypes() {
      this.dataService.getParentSourceTypes().subscribe((response: any) => {
          if (response && response.Data != null) {
              this.sourceTypeList = response.Data;
          }
      });
    }

    getPartSystems() {
      this.dataService.getPartSystems().subscribe((response: any) => {
              if (response != null && response.Success) {
                  this.partSystemList = response.Data;
                  // this.partSystemList = this.excludeAlreadyAssignedPartSystems(this.partSystemList);
              }
          });
  }
    getPackageTypes() {
        this.dataService.getPackageTypes().subscribe((response: any) => {
            if (response && response.Data != null) {
                this.packageTypeList = response.Data;
            }
        });
    }
}

